import React from 'react';

export default function LoadingBlocks() {
  return (
    <span className={'full-width padding-2'}>
      <img
        className="center-block"
        src="https://clarovideocdn0.clarovideo.net/fe/sitesplus/sk_core/images/cargando.gif"
        width="54"
      />
    </span>
  );
}
